/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

/**
 * Language and region of a generated SDS document.
 */
export type SdsLocale = (typeof SdsLocale)[keyof typeof SdsLocale];

export const SdsLocale = {
    /** English for the United States. */
    EN_US: "EN_US",
    /** English for Canada. */
    EN_CA: "EN_CA",
    /** French for Canada. */
    FR_CA: "FR_CA",
    /** German for Germany. */
    DE_DE: "DE_DE",
    /** English for Australia. */
    EN_AU: "EN_AU",
    /** Japanese for Japan. */
    JA_JP: "JA_JP",
} as const;
